import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';
import LazyLoad from 'react-lazyload';
const Supw = () => {
    useEffect(() => {
        document.title = 'SUPW -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>SUPW </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Activities</li>
                            <li>|</li>
                            <li> SUPW </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                     <div className="col-lg-12">
                     <p>Socially Useful and Productive Work (SUPW) is a  mandatory part of the school curriculum. SUPW may be described as purposive and meaningful manual work, resulting in either goods or services which are useful to the community. SUPW programme in the school is an important means of operationalizing the ideals of 'Green India Clean India'. The elements of green school (environmental, intellectual, academic, social, cultural, spiritual, aesthetic and moral greeneries) is developed and manifested through the various SUPW programmes that the students plan and carry out not only during the school sessions but also during the vacations. This emphasis on providing socially useful and productive experiences to students is aimed at bringing students closer to the real understanding of socio-economic and cultural needs of their society. It aims to help develop among the students the habit to work as a community and encourage community thinking. Working together, students learn to solve problems and make decisions and successfully contribute to their community. They connect local concerns with global issues and gain awareness of others. All this will serve them now and years later as they transition out of school and into the world of work. </p>
                     </div>
                </div>
                <div className="row sports"> 
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/supa1.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/supa1.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/supa2.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/supa2.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/supa3.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/supa3.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/supa4.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/supa4.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/supa5.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/supa5.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/supa6.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/supa6.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                     <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/supa7.jpg">
                            <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/supa7.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
                    </a>
                </LazyLoad>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                <LazyLoad>
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/supa8.jpg">
                       <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/supa8.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
               </a>
           </LazyLoad>
           </div>
           <div className="col-xl-3 col-lg-4 col-md-6 col-12">
           <LazyLoad>
              <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/SHSSB/public/Images/supa9.jpg">
                  <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/supa9.jpg" className="img-fluid" alt="Sacred Heart School, Ballia - U.P."/>
          </a>
      </LazyLoad>
      </div>
            </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default Supw